"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.Name = exports.HomeBreadcrumbRoot = exports.BreadcrumbsActiveRoot = exports.BreadcrumbRoot = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _reactRouterDom = require("react-router-dom");
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { isCategoryPage, theme } = param;
    return {
        margin: theme.spacing(5, 'auto', 0),
        padding: theme.spacing(0, 12),
        ...isCategoryPage && {
            maxWidth: 984,
            margin: theme.spacing(5, 'auto', 4),
            padding: 0
        },
        [theme.breakpoints.down(768)]: {
            display: 'none'
        }
    };
});
const getBreadcrumbsItemStyles = (theme)=>({
        display: 'inline-block',
        position: 'relative',
        height: 20,
        padding: theme.spacing(0, 2),
        opacity: 0.4,
        color: theme.palette.text.primary,
        fontSize: '1.2rem',
        lineHeight: '2rem',
        textDecoration: 'none',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        '&:hover': {
            opacity: 1,
            color: theme.palette.common.black
        },
        '&:focus': {
            color: theme.palette.text.primary
        },
        '&:after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            right: -3,
            width: 4,
            height: 4,
            marginTop: -3,
            transform: 'rotate(45deg) translateZ(0)',
            borderTop: "1px solid ".concat(theme.palette.grey[700]),
            borderRight: "1px solid ".concat(theme.palette.grey[700])
        },
        '&:first-of-type': {
            paddingLeft: 0
        }
    });
const HomeBreadcrumbRoot = exports.HomeBreadcrumbRoot = (0, _mui.styled)('a')((param)=>{
    let { theme } = param;
    return {
        ...getBreadcrumbsItemStyles(theme)
    };
});
const BreadcrumbRoot = exports.BreadcrumbRoot = (0, _mui.styled)(_reactRouterDom.Link)((param)=>{
    let { theme } = param;
    return {
        ...getBreadcrumbsItemStyles(theme)
    };
});
const BreadcrumbsActiveRoot = exports.BreadcrumbsActiveRoot = (0, _mui.styled)('a')((param)=>{
    let { theme } = param;
    return {
        display: 'inline-block',
        position: 'relative',
        height: 20,
        padding: theme.spacing(0, 2),
        opacity: 1,
        color: theme.palette.common.black,
        fontSize: '1.2rem',
        lineHeight: '2rem',
        textDecoration: 'none',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        maxWidth: 160,
        overflow: 'hidden',
        fontWeight: theme.typography.fontWeightBold,
        textOverflow: 'ellipsis',
        '&:after': {
            display: 'none'
        },
        '&:first-of-type': {
            paddingLeft: 0
        },
        '&:hover': {
            color: theme.palette.common.black
        }
    };
});
const Name = exports.Name = (0, _mui.styled)('span')({
    display: 'block',
    maxWidth: 160,
    height: 20,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
